// extracted by mini-css-extract-plugin
export default {"errorDiv":"NotFoundCard_errorDiv__L3jcH","NotFound":"NotFoundCard_NotFound__a5zfs"};